"use client";

import Recommendations from "@/app/ec/product/recommendations/recommendations";
import { useLocationDetails } from "@/app/hooks/useLocationDetails";
import { RecentlyViewedItems } from "@/components/recentlyViewedItems/recentlyViewedItems";
import styles from "./algoliaProductRecommendationsSection.module.scss";

const AlgoliaProductRecommendationsSection = ({
  mpId,
  brandName,
  categories,
  availabilityState,
}: {
  mpId: number;
  brandName: string;
  categories: CategoryTree[];
  availabilityState?: string;
}) => {
  const { zipCode } = useLocationDetails();
  const lowestCategory = categories?.length > 0 ? categories[categories.length - 1].name : "";
  const secondLowestCategory = categories?.length > 1 ? categories[categories.length - 2].name : lowestCategory;
  const isNotForSale = availabilityState === "not-for-sale";

  const moreFromOtherBrands = (
    <Recommendations
      title={`More From Other Brands`}
      titleClassName={styles.pdpTitle}
      model="related-products"
      fallbackModel="trending-items"
      objectIDs={[mpId + ""]}
      modelParams={{
        fallbackParameters: {
          filters: `NOT brand: "${brandName}" AND availability:Y`,
        },
        queryParameters: {
          filters: `NOT brand: "${brandName}" AND availability:Y`,
        },
      }}
      fallbackModelParams={{
        queryParameters: {
          query: "",
          filters: `NOT brand: "${brandName}" AND availability:Y`,
        },
        fallbackParameters: {
          query: "",
          filters: `NOT brand: "${brandName}" AND availability:Y`,
        },
      }}
      postalCode={zipCode}
      orderBy="priority"
    />
  );

  return (
    <>
      <div id="product1_rr" className={`product-recommendations-pdp-slider ${styles.pdpSlider}`}>
        <Recommendations
          title="Customers Who Bought This Also Bought"
          titleClassName={styles.pdpTitle}
          model="bought-together"
          fallbackModel="trending-items"
          objectIDs={[mpId + ""]}
          modelParams={{
            queryParameters: {
              query: "",
              filters: `availability:Y`,
            },
          }}
          fallbackModelParams={{
            queryParameters: {
              query: "",
              filters: `categoryPageId:"Top Sellers" AND availability:Y`,
            },
            fallbackParameters: {
              query: "",
              filters: `categoryPageId:"Top Sellers" AND availability:Y`,
            },
          }}
          postalCode={zipCode}
        />
        <Recommendations
          title="Similar to This Item"
          titleClassName={styles.pdpTitle}
          model="trending-items"
          modelParams={{
            fallbackParameters: {
              query: "",
              filters: `general_rating >= 4.5 AND (categoryPageId: "${lowestCategory}" OR categoryPageId: "${secondLowestCategory}") AND availability:Y`,
            },
            queryParameters: {
              query: "",
              filters: `general_rating >= 4.5 AND (categoryPageId: "${lowestCategory}" OR categoryPageId: "${secondLowestCategory}") AND availability:Y`,
            },
          }}
          postalCode={zipCode}
        />
      </div>
      <div id="product3_rr" className={`product-recommendations-pdp-slider ${styles.pdpSlider}`}>
        <Recommendations
          title="Related Best Sellers"
          titleClassName={styles.pdpTitle}
          model="related-products"
          modelParams={{
            fallbackParameters: {
              query: "",
              filters: `categoryPageId:"${secondLowestCategory}" AND availability:Y`,
            },
            queryParameters: {
              filters: `categoryPageId:"${lowestCategory}" AND availability:Y`,
            },
          }}
          objectIDs={["" + mpId]}
          postalCode={zipCode}
          orderBy="priority"
        />
      </div>
      <div id="product4_rr" className={`product-recommendations-pdp-slider ${styles.pdpSlider}`}>
        {availabilityState === "out-of-stock" ? (
          <Recommendations
            title={`More From ${brandName}`}
            titleClassName={styles.pdpTitle}
            model="related-products"
            fallbackModel="trending-items"
            objectIDs={[mpId + ""]}
            modelParams={{
              fallbackParameters: {
                filters: `brand: "${brandName}" AND availability:Y`,
              },
              queryParameters: {
                filters: `brand: "${brandName}" AND availability:Y`,
              },
            }}
            fallbackModelParams={{
              queryParameters: {
                query: "",
                filters: `brand: "${brandName}" AND availability:Y`,
              },
              fallbackParameters: {
                query: "",
                filters: `brand: "${brandName}" AND availability:Y`,
              },
            }}
            postalCode={zipCode}
            orderBy="priority"
          />
        ) : (
          <>
            <Recommendations
              title={`More From ${brandName}`}
              titleClassName={styles.pdpTitle}
              model="related-products"
              fallbackModel="trending-items"
              modelParams={{
                fallbackParameters: {
                  filters: `brand:"${brandName}" AND (categoryPageId:"${lowestCategory}" OR categoryPageId:"${secondLowestCategory}") AND availability:Y`,
                },
                queryParameters: {
                  filters: `brand:"${brandName}" AND categoryPageId:"${lowestCategory}" AND availability:Y`,
                },
              }}
              fallbackModelParams={{
                queryParameters: {
                  query: "",
                  filters: `brand:"${brandName}" AND availability:Y`,
                },
                fallbackParameters: {
                  query: "",
                  filters: `brand:"${brandName}" AND availability:Y`,
                },
              }}
              objectIDs={["" + mpId]}
              postalCode={zipCode}
              orderBy="priority"
            />
            {!isNotForSale && moreFromOtherBrands}
          </>
        )}
      </div>
      {isNotForSale && (
        <div id="product2_rr" className={`product-recommendations-pdp-slider ${styles.pdpSlider}`}>
          {moreFromOtherBrands}
        </div>
      )}
      <div id="productrv_rr" className={`product-recommendations-pdp-slider ${styles.pdpSlider}`}>
        <RecentlyViewedItems sectionHeaderClassName={styles.pdpTitle} />
      </div>
    </>
  );
};

export default AlgoliaProductRecommendationsSection;
